import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var BreadcrumbStyle = function BreadcrumbStyle(props) {
  var _getThemeData = getThemeData(props, 'breadcrumb'),
    fontColor = _getThemeData.fontColor,
    fontSize = _getThemeData.fontSize,
    lastChildFontSize = _getThemeData.lastChildFontSize,
    lastChildFontColor = _getThemeData.lastChildFontColor;
  var _getThemeData2 = getThemeData(props, 'common'),
    primary6 = _getThemeData2.primary6;
  return css([".c7n-breadcrumb.c7n-breadcrumb{color:", ";font-size:", ";cursor:pointer;span{&:hover{color:", ";}}& > span:last-child{color:", ";font-size:", "px;}}"], fontColor, fontSize, primary6, lastChildFontColor, lastChildFontSize);
};
export default BreadcrumbStyle;